;(function () {
	const initProductAccordion = () => {
		const aboutToggleItems = $('.about__accordion-toggle')

		aboutToggleItems.each(function () {
			const currentToggle = $(this)
			const siblingToggles = currentToggle.siblings(
				'.about__accordion-description'
			)

			currentToggle.click(function () {
				if (!currentToggle.hasClass('active')) {
					aboutToggleItems.each(function () {
						const siblingToggle = $(this)
						siblingToggle.removeClass('active')
						siblingToggle
							.siblings('.about__accordion-description')
							.stop()
							.slideUp(300)
					})

					currentToggle.addClass('active')

					siblingToggles.stop().slideDown(300)
				} else {
					currentToggle.removeClass('active')
					siblingToggles.stop().slideUp(300)
				}
			})
		})
	}

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			'.product-media-modal__content'
		)
		const images = imagesWrapper?.querySelectorAll('.js-image-zoom') || []

		images.forEach((el) => {
			el.addEventListener('click', (e) => {
				imagesWrapper.classList.toggle('zoom')
			})
		})
	}

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
		const formatString = theme.moneyFormat

		return formatString.replace(placeholderRegex, value)
	}

	const setTotalFreeShipping = () => {
		if (document.querySelector('.js-free-shipping')) {
			const freeShippingTotal = document.querySelector('.free-shipping-total')
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend)
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`
				}
			}
		}
	}
	function changeIconsViewBox() {
		const textWithIcon = document.querySelectorAll('.text_with_icon')
		textWithIcon.forEach((item) => {
			const icons = item.querySelectorAll('.icon-pack')
			icons.forEach((icon) => {
				icon.setAttribute('viewBox', '0 0 20 20')
			})
		})
	}

	const navigationSections = [
		{
			sectionSelector: '#overview',
			linkSelector: '#overview-link',
		},
		{
			sectionSelector: '#product-specifications',
			linkSelector: '#specifications-link',
		},
	]

	let navigationScrollHandler
	let navigationRafId

	function getFooterElement() {
		return document.querySelector(
			'.ukoi-footer, .footer, footer[role="contentinfo"], footer'
		)
	}

	function isNavigationNearFooter(navigation) {
		const footer = getFooterElement()
		if (!footer || !navigation) return false

		return (
			window.innerHeight + window.scrollY - navigation.offsetHeight >
			footer.offsetTop
		)
	}

	function updateNavigation(sections) {
		const navigation = document.querySelector('.product__media_navigation')
		if (!navigation) return

		navigation.classList.add('show-navigation')

		sections.forEach((section) => {
			if (!section) return

			const sectionElement = document.querySelector(section.sectionSelector)
			const linkElement = document.querySelector(section.linkSelector)
			if (!linkElement) return

			if (!sectionElement) {
				linkElement.style.display = 'none'
				return
			}

			linkElement.style.display = ''
			const rect = sectionElement.getBoundingClientRect()
			linkElement.classList.toggle(
				'active',
				rect.top <= 1 && rect.top > rect.height * -1
			)

			if (!linkElement.dataset.productNavigationBound) {
				linkElement.dataset.productNavigationBound = 'true'
				linkElement.addEventListener('click', () => {
					sectionElement.scrollIntoView({behavior: 'smooth'})
				})
			}
		})

		const secondSection = document.querySelectorAll('#MainContent .shopify-section')[1]
		const isSecondSectionScrolled = secondSection
			? secondSection.getBoundingClientRect().top < 0
			: window.scrollY > 0
		const isNearFooter = isNavigationNearFooter(navigation)

		navigation.style.transform = isSecondSectionScrolled && !isNearFooter
			? 'translateX(-50%) translateY(0)'
			: 'translateX(-50%) translateY(calc(100% + 16px))'
	}

	function navigationInit(sections) {
		const navigation = document.querySelector('.product__media_navigation')
		if (!navigation) return

		navigation.style.transform = 'translateX(-50%) translateY(calc(100% + 16px))'

		if (navigationScrollHandler) {
			document.removeEventListener('scroll', navigationScrollHandler)
		}

		navigationScrollHandler = () => {
			if (navigationRafId) return
			navigationRafId = requestAnimationFrame(() => {
				navigationRafId = null
				updateNavigation(sections)
			})
		}

		document.addEventListener('scroll', navigationScrollHandler, {passive: true})
		updateNavigation(sections)
	}

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion()
		initZoomImage()
		setTotalFreeShipping()
		changeIconsViewBox()
		navigationInit(navigationSections)
	})

	navigationInit(navigationSections)
	initProductAccordion()
	initZoomImage()
	setTotalFreeShipping()
	changeIconsViewBox()
})()

;(function () {
	const mobileQuery = window.matchMedia('(max-width: 989px)')
	let observer

	const styles = `
		@media (max-width: 989px) {
			.product__media_navigation {
				left: 0 !important;
				right: 0 !important;
				bottom: 0 !important;
				width: 100% !important;
				max-width: none !important;
				min-height: 8.4rem;
				display: none;
				grid-template-columns: minmax(0, 1fr) minmax(12.6rem, 39%) !important;
				gap: 1.4rem !important;
				align-items: center !important;
				padding: 1rem 1.6rem calc(0.65rem + env(safe-area-inset-bottom)) !important;
				border-radius: 0 !important;
				border-top: 0.1rem solid rgba(var(--color-border), 0.65);
				background: #fff !important;
				box-shadow: 0 -0.8rem 2rem rgba(0, 0, 0, 0.08) !important;
				transform: translateY(calc(100% + 1.6rem + env(safe-area-inset-bottom))) !important;
				z-index: 40 !important;
			}

			.product__media_navigation.show-navigation {
				display: grid !important;
			}

			.product__media_navigation.mobile-navigation-visible {
				transform: translateY(0) !important;
			}

			.product__media_navigation-title {
				width: 100% !important;
				max-width: 100% !important;
				display: flex !important;
				flex-direction: column !important;
				align-items: flex-start !important;
				justify-content: center !important;
				gap: 0.12rem !important;
				min-width: 0 !important;
				font-size: 1.2rem;
				line-height: 1.3;
			}

			.product__media_navigation-title-text {
				display: -webkit-box !important;
				-webkit-box-orient: vertical !important;
				-webkit-line-clamp: 2 !important;
				overflow: hidden !important;
				text-overflow: ellipsis !important;
				white-space: normal !important;
				font-weight: 400 !important;
			}

			.product__media_navigation-price {
				justify-self: start;
				min-width: 0;
				width: 100%;
			}

			.product__media_navigation-price .price,
			.product__media_navigation-price .price dl {
				margin: 0;
				align-items: center;
			}

			.product__media_navigation-price .price__sale {
				display: none !important;
				margin: 0;
				align-items: baseline;
				gap: 0.6rem;
			}

			.product__media_navigation-price .price--on-sale .price__sale {
				display: flex !important;
				flex-wrap: wrap;
			}

			.product__media_navigation-price .price--on-sale .price__regular {
				display: none !important;
			}

			.product__media_navigation-price .price__unit,
			.product__media_navigation-price .unit-price,
			.product__media_navigation-price .price__availability,
			.product__media_navigation-price .price__badge-sale,
			.product__media_navigation-price .price__badge-sold-out {
				display: none !important;
			}

			.product__media_navigation-price .price {
				font-size: 1.2rem;
				line-height: 1.2;
			}

			.product__media_navigation-price .price-item--sale {
				order: 1;
				font-weight: 600 !important;
				color: #111 !important;
			}

			.product__media_navigation-price .price__sale .price-item--regular {
				order: 2;
				font-weight: 400 !important;
				color: rgba(23, 23, 23, 0.58) !important;
				text-decoration: line-through !important;
			}

			.product__media_navigation-price .price-item--sale,
			.product__media_navigation-price .price > .price__regular .price-item--regular {
				font-size: 1.2rem !important;
			}

			.product__media_navigation-list {
				display: none !important;
			}

			.product__media_navigation-btn {
				width: 100% !important;
				display: block !important;
				min-width: 0 !important;
			}

			.product__media_navigation-btn product-form,
			.product__media_navigation-btn .product-form,
			.product__media_navigation-btn .product-form__buttons,
			.product__media_navigation-btn .product-form__buttons-row,
			.product__media_navigation-btn .product-form__checkout,
			.product__media_navigation-btn .product-form__submit,
			.product__media_navigation-btn gravity-button {
				width: 100% !important;
				max-width: none !important;
			}

			.product__media_navigation-btn .product-form__buttons-row {
				display: block !important;
			}

			.product__media_navigation-btn .product-form__quantity,
			.product__media_navigation-btn .shopify-payment-button,
			.product__media_navigation-btn .recipient-form,
			.product__media_navigation-btn .product-form__error-message-wrapper {
				display: none !important;
			}

			.product__media_navigation-btn .product-form__submit,
			.product__media_navigation-btn button[type=submit],
			.product__media_navigation-btn gravity-button {
				border-radius: 999rem !important;
			}

			.product__media_navigation-btn .product-form__submit {
				min-height: 4.4rem !important;
				justify-content: center !important;
				text-align: center;
			}
		}
	`

	function injectStyles() {
		if (document.getElementById('ukoi-mobile-product-navigation-style')) return
		const style = document.createElement('style')
		style.id = 'ukoi-mobile-product-navigation-style'
		style.textContent = styles
		document.head.appendChild(style)
	}

	function ensureTitleWrapper(navigation) {
		const title = navigation.querySelector('.product__media_navigation-title')
		if (!title) return null
		if (!title.querySelector('.product__media_navigation-title-text')) {
			const label = title.textContent.trim()
			title.textContent = ''
			const text = document.createElement('span')
			text.className = 'product__media_navigation-title-text'
			text.textContent = label
			title.appendChild(text)
		}
		let price = title.querySelector('.product__media_navigation-price')
		if (!price) {
			price = document.createElement('span')
			price.className = 'product__media_navigation-price'
			title.appendChild(price)
		}
		return price
	}

	function syncPrice(navigation) {
		const priceTarget = ensureTitleWrapper(navigation)
		const source = document.querySelector('.product__info-container .price')
		if (!priceTarget || !source) return
		const clone = source.cloneNode(true)
		clone.querySelectorAll('.price__unit, .unit-price, .price__availability, .price__badge-sale, .price__badge-sold-out').forEach((element) => element.remove())
		priceTarget.innerHTML = ''
		priceTarget.appendChild(clone)
	}

	function updateMobileVisibility(navigation) {
		if (!mobileQuery.matches) {
			navigation.classList.remove('mobile-navigation-visible')
			return
		}

		const footer = document.querySelector('.ukoi-footer, .footer, footer[role="contentinfo"], footer')
		const secondSection = document.querySelectorAll('#MainContent .shopify-section')[1]
		const pastProductIntro = secondSection ? secondSection.getBoundingClientRect().top < 0 : window.scrollY > 360
		const nearFooter = footer ? window.innerHeight + window.scrollY - navigation.offsetHeight > footer.offsetTop : false
		navigation.classList.toggle('mobile-navigation-visible', pastProductIntro && !nearFooter)
	}

	function initMobileProductNavigation() {
		const navigation = document.querySelector('.product__media_navigation')
		if (!navigation) return
		injectStyles()
		syncPrice(navigation)
		updateMobileVisibility(navigation)

		if (observer) observer.disconnect()
		const priceSource = document.querySelector('.product__info-container .price')
		if (priceSource) {
			observer = new MutationObserver(() => syncPrice(navigation))
			observer.observe(priceSource, { childList: true, subtree: true, attributes: true })
		}
	}

	document.addEventListener('scroll', () => {
		const navigation = document.querySelector('.product__media_navigation')
		if (navigation) updateMobileVisibility(navigation)
	}, { passive: true })

	window.addEventListener('resize', () => {
		const navigation = document.querySelector('.product__media_navigation')
		if (navigation) updateMobileVisibility(navigation)
	}, { passive: true })

	document.addEventListener('variant:change', initMobileProductNavigation)
	document.addEventListener('shopify:section:load', initMobileProductNavigation)
	document.addEventListener('DOMContentLoaded', initMobileProductNavigation)
	initMobileProductNavigation()
})()
